exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-c2586abc]{font-size:1rem;margin-bottom:5px;color:#222}.has-error label[data-v-c2586abc]{color:#dc3545}", ""]);

// exports
